import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePlatoAvailable } from "@/contexts/contact/hooks";
import { useContactingTestId } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Divider } from "@gemini/ui";
import { BookVisitButton } from "../Buttons";
export const ContactFormPlato = ({ showDivider = true, tracking, }) => {
    const testId = useContactingTestId("ContactForm");
    const { t } = useI18n();
    const isPlatoAvailable = usePlatoAvailable();
    // @ts-ignore
    const { avZone } = tracking;
    if (!isPlatoAvailable)
        return;
    return (_jsxs(Box, { width: "100%", marginTop: {
            "breakpoint.base": "spacing.12",
            "breakpoint.xxxl": "spacing.16",
        }, children: [_jsx(BookVisitButton, { av_zone: avZone, rootTestId: testId, children: t("contact.card.book_visit") }), showDivider && (_jsx(Divider, { "aria-hidden": "true", marginTop: {
                    "breakpoint.base": "spacing.12",
                    "breakpoint.xxxl": "spacing.16",
                } }))] }));
};
